import { Roles } from '../../../../shared/constants'

export default () => ({
  path: 'upload',
  name: 'operations-upload',
  component: () => import(/* webpackChunkName: "operations-upload" */ '../../../views/Operations/OperationsUpload'),
  meta: {
    title: 'Upload',
    allowedUserRoles: [Roles.RADAR_OPS_LEGACY, Roles.RADAR_OPS],
  },
})
